module.exports = "<img *ngIf=url [src]=url alt=\"{{ 'CameraManagement.ChannelThumbnail' | translate }}\"/> ";